export class PelletizingProductQuality {
    constructor({
          id= null, 
          planCode= ``, 
          day= ``,
          locName= ``,          
          shift='',
          productName= ``,
          Cr2O3= ``,
          CaO= ``,
          MgO= ``,
          Al2O3= ``,
          SiO2= ``,
          Fe= ``,
          CrFe= ``,
          drum= ``,
          intensity= ``,
      } = {}) {
      this.id = id;
      this.planCode = planCode;
      this.day = day;
      this.locName = locName;     
      this.shift = shift;  
      this.productName = productName;
      this.Cr2O3 = Cr2O3;
      this.CaO = CaO;
      this.MgO = MgO;
      this.Al2O3 = Al2O3;
      this.SiO2 = SiO2;
      this.Fe = Fe;
      this.CrFe = CrFe;
      this.drum = drum;
      this.intensity = intensity;
    }
  }
  export function gridFields() {
    return Object.freeze([         
        {
          key: 'planCode',
          label: 'lbl.basic.planCode',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'locName',
          label: 'lbl.basic.locName',
          sortable: true,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'day',
          label: 'lbl.basic.day',
          sortable: true,
          form: {
            type: 'datepicker'
          }
        },  
        {
          key: 'shift',
          label: 'lbl.basic.shift',
          sortable: true,
          form: {
            type: 'input'
          }
        },                       
        {
          key: 'productName',
          label: 'lbl.prd.execution.productionName',
          sortable: false,
          form: {
            type: 'input'
          }
        }, 
        {
          key: 'Cr2O3',
          label: 'Cr2O3',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'CaO',
          label: 'CaO',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'MgO',
          label: 'MgO',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'Al2O3',
          label: 'Al2O3',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'SiO2',
          label: 'SiO2',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'Fe',
          label: 'Fe',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'CrFe',
          label: 'Cr/Fe',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'drum',
          label: 'lbl.prd.execution.drum',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'intensity',
          label: 'lbl.prd.execution.intensity',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        
        {
          key: 'cokeConcentration',
          label: 'lbl.prd.execution.cokeConcentration',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'cokeSize',
          label: 'lbl.prd.execution.cokeSize',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'cokeCarbon',
          label: 'lbl.prd.execution.cokeCarbon',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'cokeCaO',
          label: 'lbl.prd.execution.cokeCaO',
          sortable: false,
          form: {
            type: 'input'
          }
        },
        {
          key: 'operate',
          label: 'lbl.basic.update',
          form: {
              type: 'formatter'
          }
        }
    ]);
  }
  export const fields = Object.freeze(Object.keys(new PelletizingProductQuality()).map(i => 'entity.' + i));
  export const filterFields = [
    'filter.planCodeFilter',
    'filter.plantFilter',
    'filter.shiftFilter',
    'filter.startDayFilter',
    'filter.endDayFilter',     
  ];
  export const filter = {
    'planCodeFilter': "", 
    'plantFilter': "",
    'shiftFilter': "",
    'startDayFilter': "",
    'endDayFilter': "",
  };